import { NgModule } from '@angular/core';

import {SharedModule} from '../shared/shared.module';
import { MyListProductComponent } from './my-list-product/my-list-product.component';
import { MyItemProductComponent } from './my-item-product/my-item-product.component';
import { MyDetailProductComponent } from './my-detail-product/my-detail-product.component';
import {SortPipe} from './shared/sort.pipe';
import {FileUploadService} from './shared/file-upload.service';
import {ProductsCacheService} from './shared/products-cache.service';
import {ProductRatingService} from './shared/product-rating.service';
import { SidebarFiltersComponent } from './my-list-product/sidebar-filters/sidebar-filters.component';
import {UiService} from './shared/ui.service';
import {CategoryGuard} from './shared/category.guards';

@NgModule({
  declarations: [
    MyListProductComponent,
       MyItemProductComponent,
       MyDetailProductComponent,
       SidebarFiltersComponent,
  ],
  imports: [
    SharedModule
  ],
    exports: [MyListProductComponent, MyItemProductComponent],
  providers: [SortPipe, FileUploadService, ProductsCacheService, ProductRatingService,UiService]
})
export class MyProductsModule {}
